export default [
  {
    path: '/',
    name: 'Cursos',
    component: () => import('./ListCourses.vue'),
    meta: {
      pageSection: 'Cursos',
      pageTitle: 'Lista de cursos',
      requiresAuth: true,
      is_teacher: false,
    },
  },
]
